import React, {Component, useEffect, useState} from "react";

import {Button, Col, Descriptions, message, Row, Select, Spin, Tabs, Modal, Alert} from "antd";
import DescriptionsItem from "antd/es/descriptions/Item";

import {Forecasts} from "./Forecasts";
import {MaterialCard} from "./MaterialCard";
import {RecommendationsTable} from "./RecommendationsTable";
import api from "../../api";
import {extractErrorMessage} from "../../index";
import * as Auth from "../../AuthService";
import {CurrentUserContext} from "../../contexts/AuthContext";
import {checkAllPermissions, checkAnyOfPermissions, getProjectId, getURLParam, labelMapper, createIHLink} from "../../helpers";
import {ROP_MIN_LABEL, SHOW_STANDARD_RECOMMENDATIONS} from "../../properties";
import {DataCard} from "../helpers/cards/Card";
import {GetBack, ScenarioLink} from "../helpers/cards/MaterialBlock";
import {EditingMaterialModal} from "../helpers/modals/EditingMaterialModal";
import {HistoryModal} from "../helpers/modals/HistoryModal";
import {ModalWindow} from "../helpers/modals/ModalWindow";
import {StandardTable} from "../helpers/TablePanel";
import {CustomDescriptions} from "../settings/MinMaxSettings";
import {AssignApproval} from "../workflows/AssignApproval";
import {getStatusTag} from "../workflows/BucketApproveViewer";
import {ExtendedWhereUsedFactors, StockingCalculator, Recommendations, MaterialInfo, FieldsNaming} from "../../variants";
import {PageTitle} from "../helpers/PageTitle";

const {TabPane} = Tabs;

export class MinMaxItem extends Component {
	constructor(props) {
		const projectId = getProjectId(props.location);

		const material = getURLParam("material");
		const from = getURLParam("from");
		super(props);
		this.state = {
			projectId: projectId,
			material: material,
			shouldSelectWorkflow: true,
			editModal: false,
			canEdit: false,
			canEditRanking: false,
			presentOutput: [],
			possibleScenarios: [],
			settingsOptions: [
				{
					label: "Settings",
					options: [],
				},
				{
					label: "Scenario",
					options: [],
				},
			],
			selectedSetting: "material",
			canApprove: false,
			historyModal: false,
			historyCount: null,
			from: from,
			hasRights: true,
			change: false,
			leadTime: [],
			currentTab: "11",
			currentRec: "[MM Data] Current",
			unrankedRecs: [],
			rankedRecs: [],
			recommendedData: [],
			data: [],
			materialSettings: {},
			resolvedServiceLevel: null,
			forecastMethod: "naive",
			itemInfo: {
				description: "",
				rop: "",
				max: "",
				Type: "",
			},
			weightCalc: {
				total: {
					weight: 0,
					score: 0,
				},
			},
			exceptions: [],
			showExtraTable: false,
		};
	}

    toggleExtraTable = () => {
        this.setState(prevState => ({ showExtraTable: !prevState.showExtraTable }));
    };

	getAnalysis() {
		api.get(`/projects/${this.state.projectId}/material-analysis/${this.state.material}/itemInfo`, {omitGlobalError: true})
			.then(json => {
				this.setState({itemInfo: json.data.itemInfo});
				if (json.data.itemInfo.approved) {
					this.setState({
						forecastMin: json.data.itemInfo.appr_min,
						forecastMax: json.data.itemInfo.appr_max,
					});
				}
				this.getHistoryCount(json.data.itemInfo._id);
				this.refreshRecommendations();
			})
			.catch(async e => {
				const status = e.response?.status;
				if (status === 403) {
					window.open(this.state.from, "_self");
				} else if (status === 500) {
					message.error("We can't find the material in our data. Redirecting ...", 5, () => {
						const backUrl = this.state.from || `/projects/${this.state.projectId}/dashboard-v2`;
						window.open(backUrl, "_self");
					});
				} else {
					message.error(await extractErrorMessage(e));
				}
			});
	}

	getRecs = useMl => {
		const selectedSetting = this.state.selectedSetting;
		if (useMl) {
			this.setState({mlLoading: true});
			message.info("Getting the AIML recommendation");
		} else {
			this.setState({standardLoading: true});
			message.info("Getting the recommendations");
		}

		api.get(
			`/projects/${this.state.projectId}/material-analysis/${this.state.material}/recommendations?type=unranked&ml=${useMl}`,
			{params: {settings_type: selectedSetting}},
		)
			.then(json => {
				if (this.state.selectedSetting !== selectedSetting) return;
				this.setState({unrankedRecs: json.data, getRanked: false});
				message.loading("Starting the process of ranking the recommendations");
			})
			.catch(e => {
				if (e.response.status === 403) {
					window.open(this.state.from, "_self");
				}
			})
			.finally(() => {
				if (useMl) {
					this.setState({mlLoading: false});
				} else {
					this.setState({standardLoading: false});
				}
			});
	};

	getHistoryCount = (_id) => {
		api.get(`/projects/${this.state.projectId}/materials/${_id}/history?material=${this.state.material}`)
			.then(json => this.setState({historyCount: json.data.length}))
			.catch(() => this.setState({historyCount: 0}));
	};

	componentDidMount() {
		api.get(`/projects/${this.state.projectId}/settings`, Auth.createConfig()).then(json =>
			this.setState({slTable: json.data.constants.service_factor_table}),
		);

		this.getAnalysis();
		this.checkAdminPermission();
		this.checkRankingPermission();
		this.checkCanApprovePermission();
		this.getLeadTime();
		this.getValues("global");
		this.getValues(this.state.material);
		this.getScenarios();
		this.getExceptions();
	}

	getScenarios = () => {
		api.get(`/projects/${this.state.projectId}/iterations/${this.state.material}`)
			.then(json => {
				this.setState(prevState => {
					const options = [...prevState.settingsOptions];
					options[1] = {
						...options[1],
						options: json.data.scenarios.map(scenario => ({
							value: scenario["_id"],
							label: scenario["iteration_name"],
						}))
					};
					return {
						settingsOptions: options,
						possibleScenarios: json.data.scenarios,
					};
				});
				this.getOutput(json.data.scenarios);
			})
			.catch(error => console.log(error));
	};

	getOutput = scenarios => {
		api.post(`/projects/${this.state.projectId}/scenario-outcome/${this.state.material}`, {
			scenarios: scenarios.map(scenario => scenario["_id"]),
		}).then(json => {
			this.setState({
				presentOutput: json.data,
			});
		});
	};

	getValues = _type => {
		if (_type === "global") {
			api.get(`/projects/${this.state.projectId}/global-settings`)
				.then(json => {
					this.setState(prevState => {
						const options = [...prevState.settingsOptions];
						const groupOptions = options[0].options.filter(opt => opt.value !== "global");
						options[0] = {
							...options[0],
							options: [...groupOptions, { value: "global", label: "Global Settings" }]
						};
						return {
							globalSettings: json.data.constants,
							settingsOptions: options,
						};
					});
				})
				.catch(e => this.setState({globalSettings: {}}));
		} else {
			api.get(`/projects/${this.state.projectId}/settings/${_type}`)
				.then(json => {
					this.setState(prevState => {
						const options = [...prevState.settingsOptions];
						const groupOptions = options[0].options.filter(opt => opt.value !== "material");
						options[0] = {
							...options[0],
							options: [...groupOptions, { value: "material", label: "Material Settings" }]
						};
						return {
							customSettings: json.data.constants,
							settingsOptions: options,
						};
					});
				})
				.catch(e => this.setState({customSettings: {}}));
		}
	};

	checkAdminPermission = () => {
		checkAnyOfPermissions([
			"senior-user",
			"approve-user",
			"insurance-admin",
			"admin",
			"superadmin",
			"material-analyst",
			"inventory-analyst",
			"dm-maintenance",
			"dm-inventory",
			"stock-owner",
		])
			.then(() => this.setState({canEdit: true}))
			.catch(() => this.setState({canEdit: false}));
	};

	checkCanApprovePermission = () => {
		checkAllPermissions(["approve-user"])
			.then(() => this.setState({canApprove: true}))
			.catch(() => this.setState({canApprove: false}));
	};

	checkRankingPermission = () => {
		checkAnyOfPermissions(["superadmin"])
			.then(() => this.setState({canEditRanking: true}))
			.catch(() => this.setState({canEditRanking: false}));
	};

	getDiff = values => {
		const diff = [];
		for (const key of Object.keys(values)) {
			if (this.state.itemInfo.hasOwnProperty(key)) {
				if (key === "approved") {
					if (this.state.itemInfo["approved"] === "NA" && values[key]) {
						diff.push({
							key,
							old: false,
							new: true,
						});
					} else if (this.state.itemInfo[key] !== values[key]) {
						diff.push({
							key,
							old: this.state.itemInfo[key],
							new: values[key],
						});
					}
				} else if (this.state.itemInfo[key] !== values[key]) {
					diff.push({
						key,
						old: this.state.itemInfo[key],
						new: values[key],
					});
				}
			} else {
				if (["approved", "comment"].indexOf(key) > -1) {
					continue;
				}
				diff.push({
					key,
					old: "NA",
					new: values[key],
				});
			}
		}
		return diff;
	};

	getParamsForModelling = () => {
		const selectedSetting = this.state.selectedSetting;
		this.setState({modelSettings: {}});
		api.get(
			`/projects/${this.state.projectId}/material-analysis/${this.state.material}/settings?type=${selectedSetting}`,
		)
			.then(json => {
				if (this.state.selectedSetting !== selectedSetting) return;
				const value = json.data;

				for (const key of ["holding"]) {
					if (Object.keys(value).includes(key)) {
						value[key] = value[key] * 100;
					}
				}

				for (const key of ["use_pm"]) {
					if (value[key] === true) {
						value[key] = "all";
					} else if (value[key] === false) {
						value[key] = "corrective";
					}
				}

				this.setState({modelSettings: value, forecastMethod: json.data.forecast});
			})
			.catch(error => {
				console.log(error);
			});
	};

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (
			prevState.globalSettings !== this.state.globalSettings ||
			prevState.customSettings !== this.state.customSettings ||
			this.state.itemInfo !== prevState.itemInfo
		) {
			const _global = {...this.state.globalSettings};

			const _current = {...this.state.customSettings};
			for (const key of ["holding"]) {
				if (Object.keys(_global).includes(key)) {
					_global[key] = _global[key] * 100;
				}

				if (Object.keys(_current).includes(key)) {
					_current[key] = _current[key] * 100;
				}
			}

			for (const key of ["use_pm"]) {
				if (_global[key] === true) {
					_global[key] = "all";
				} else if (_global[key] === false) {
					_global[key] = "corrective";
				}

				if (_current[key] === true) {
					_current[key] = "all";
				} else if (_current[key] === false) {
					_current[key] = "corrective";
				}
			}

			const materialSettings = {..._global, ..._current};
			let resolvedServiceLevel = null;
			if (materialSettings.service_level == null) {
				const criticalities = (this.state.itemInfo.plant_info || []).map(plant =>
					(plant.material_criticality || "").split("-")[0].trim().toUpperCase(),
				);
				const category = ["A", "B", "C"].find(value => criticalities.includes(value));
				resolvedServiceLevel =
					(category ? materialSettings[`service_level_${category.toLowerCase()}`] : materialSettings.service_level_global) ??
					100;
			}

			this.setState({
				materialSettings: materialSettings,
				resolvedServiceLevel: resolvedServiceLevel,
			});

			if (Object.keys(materialSettings).includes("forecast")) {
				this.handleSelect(materialSettings["forecast"]);
			}
			this.getParamsForModelling();
		}

		if (this.state.unrankedRecs !== prevState.unrankedRecs) {
			this.getRanked();
			this.setState({recommendedData: this.state.unrankedRecs});
		}

		if (this.state.rankedRecs !== prevState.rankedRecs) {
			this.setState({recommendedData: this.state.rankedRecs});
		}

		if (this.state.selectedSetting !== prevState.selectedSetting) {
			this.setState({
				unrankedRecs: this.state.unrankedRecs.filter(rec => rec.type !== "AI/ML"),
			});
			this.getRecs(true);
			this.getParamsForModelling();
		}

		if (this.state.settingsOptions !== prevState.settingsOptions) {
			const from = this.state.from;
			if (from) {
				const chunks = from.split("/scenarios/");
				if (chunks.length > 1) {
					this.setState({
						selectedSetting: chunks[1].split("/")[0],
					});
				} else {
					this.setState({selectedSetting: "material"});
				}
			} else {
				this.setState({selectedSetting: "material"});
			}
			this.getParamsForModelling();
		}

		if (this.state.currentTab !== prevState.currentTab && prevState.currentTab === "12") {
			this.setState({
				forecastMethod: this.state.materialSettings["forecast"] || "naive",
				change: !this.state.change,
				currentRec: "[MM Data] Current",
				forecastMin: this.state.itemInfo["rop"],
				forecastMax: this.state.itemInfo["max"],
			});
		}
	}

	getSettings = selectedSetting => {
		const setting = {};
		if (["global", "material"].includes(selectedSetting)) {
			setting["type"] = "settings";
			setting["value"] = selectedSetting;
		} else {
			setting["type"] = "scenario";
			setting["value"] = selectedSetting;
		}
		return setting;
	};

	getRanked = () => {
		if (this.state.unrankedRecs.length > 0) {
			const selectedSetting = this.state.selectedSetting;
			this.setState({
				getRanked: true,
				loading: true,
			});
			const settings = this.getSettings(selectedSetting);
			api.post(
				`/projects/${this.state.projectId}/material-analysis/${this.state.material}/recommendations?type=ranked`,
				{recommendations: this.state.unrankedRecs, settings: settings},
			)
				.then(json => {
					if (this.state.selectedSetting !== selectedSetting) return;
					this.setState({rankedRecs: json.data});
					if (json.data.length > 0) {
						this.setState({weightCalc: json.data[0].weight});
					}
				})
				.catch(e => {
					if (e.response.status === 403) {
						window.open(this.state.from, "_self");
					}
				})
				.finally(() => {
					this.setState({
						getRanked: true,
						loading: false,
					});
				});
		}
	};

	removeKeys = values => {
		const data = {...values};
		delete data["appr_min"];
		delete data["appr_max"];
		return data;
	};

	getLeadTime = () => {
		api.get(`/projects/${this.state.projectId}/material-analysis/${this.state.material}/leadTime`).then(json =>
			this.setState({leadTime: json.data}),
		);
	};

	getExceptions = () => {
		api.get(
			`/projects/${this.state.projectId}/exception-reporting/material/messages?material=${this.state.material}`,
		)
			.then(json => {
				this.setState({exceptions: json.data});
			})
			.catch(error => {
				console.error("Failed to fetch exception messages:", error);
			});
	};

	save = (values, form) => {
		const diff = this.getDiff(values);
		if (diff.length === 0) {
			this.close();
		}
		if (!values.approved) {
			values = this.removeKeys(values);
		}
		const data = {
			values: {...values},

			add_info: {
				user: this.context.email(),
				material: this.state.material,
				date: new Date(),
				comment: values.comment,
				changed: diff,
			},
		};

		message.info("Saving...");
		api.post(`/projects/${this.state.projectId}/materials/${this.state.itemInfo._id}/save`, data)
			.then(() => {
				message.success("Your changes were saved");
				this.setState({editModal: false});
				this.getAnalysis();
			})
			.catch(() => {});
	};

	close = () => {
		this.setState({historyModal: false});
	};

	handleSelect = values => {
		this.setState({forecastMethod: values});
	};

	startApproval = item => {
		this.setState({
			show: true,
			shouldSelectWorkflow: false,
			proposedMin: item["min"],
			proposedMax: item["max"],
		});
	};

	closeApproval = () => {
		this.setState({
			shouldSelectWorkflow: true,
			show: false,
		});
	};

	onForecastOpen = item => {
		this.setState({
			currentTab: "12",
			forecastMethod: this.state.modelSettings["forecast"] || "naive",
			currentRec: `[${item.type}] ${item.name}`,
			change: !this.state.change,
			forecastMin: item["min"],
			forecastMax: item["max"],
		});
	};

	createSLAttributes = attributes =>
		attributes &&
		attributes.map(a => ({
			value: a["sl"],
			label: `Service Level: ${a.sl}%, CSF -  ${a.csf}`,
		}));

	handleSave = value => {
		const hasFlocs = this.state.itemInfo?.equipment_info && this.state.itemInfo.equipment_info.length > 0;

		const proceedSave = () => {
		if (value.service_level !== undefined &&
			this.state.resolvedServiceLevel != null &&
			value.service_level === this.state.resolvedServiceLevel) {
			delete value.service_level;
		}

		for (const key of Object.keys(value)) {
			if (key === "service_level") {
				value["csf"] = this.state.slTable.filter(v => v.sl === value["service_level"])[0]["csf"];
			}
		}

		const _globalSettings = {...this.state.materialSettings, ...value};

		_globalSettings["holding"] = _globalSettings["holding"] / 100;
		api.post(`/projects/${this.state.projectId}/settings/save/${this.state.material}`, _globalSettings).then(() => {
			message.success("Material Settings were updated successfully!");
			this.getValues(this.state.material);
			this.getAnalysis();
			message.info("Start re-ranking the recommendations");
			this.getRanked();
		});
		};

		if (value.ranking_applied === "stocking_calculator" && !hasFlocs) {
			Modal.confirm({
				title: "Warning",
				content: "This material is not attached to any floc, you sure you want to switch?",
				okText: "Yes",
				cancelText: "No",
				onOk: proceedSave,
			});
		} else {
			proceedSave();
		}
	};

	getSettingsValues = () => {
		const {materialSettings, resolvedServiceLevel} = this.state;
		return resolvedServiceLevel == null ? materialSettings : {...materialSettings, service_level: resolvedServiceLevel};
	};

	getRecommendations = () => [...this.state.recommendedData];

	getAdjustableSettings = () =>
		Recommendations.refineSettings([
			{
				label: "Service Level",
				key: "service_level",
				editable: this.state.canEdit,
				formFields: [
					{
						label: "Service Level",
						name: "service_level",
						_type: "select-object",
						message: "Error",
						required: true,
						options: this.createSLAttributes(this.state.slTable),
					},
				],
			},
			{
				label: "Holding Cost (%)",
				key: "holding",
				editable: this.state.canEdit,
				formFields: [
					{
						label: "Holding Cost (%)",
						name: "holding",
						_type: "number",
						message: "Error",
						required: true,
					},
				],
			},
			{
				label: "Forecast Demand",
				key: "use_pm",
				editable: this.state.canEdit,
				formFields: [
					{
						label: "Forecast Demand",
						name: "use_pm",
						_type: "select-object",
						message: "Error",
						required: true,
						options: [
							{
								value: "all",
								label: "All",
							},
							{
								value: "corrective",
								label: "Corrective",
							},
							{
								value: "planned",
								label: "Planned",
							},
						],
					},
				],
			},
			{
				label: "EOQ Demand",
				key: "eoq_demand",
				editable: this.state.canEdit,
				formFields: [
					{
						label: "EOQ Demand",
						name: "eoq_demand",
						_type: "select-object",
						message: "Error",
						required: true,
						options: [
							{
								value: "all",
								label: "All",
							},
							{
								value: "corrective",
								label: "Corrective",
							},
							{
								value: "planned",
								label: "Planned",
							},
						],
					},
				],
			},
			{
                label: "Order Cost",
                key: "order_cost",
                editable: this.state.canEdit,
                formFields: [
                    {
                        label: "Order Cost",
                        name: "order_cost",
                        _type: "number",
                        message: "Error",
                        required: true,
                    },
                ],
            },
			{
				label: "Exclude SDC Codes",
				key: "skip_sdc",
				editable: true,
				formFields: [
					{
						label: "Exclude SDC codes",
						name: "skip_sdc",
						_type: "select-tag",
						required: false,
						options:
							this.state.itemInfo.sdc_code &&
							this.state.itemInfo.sdc_code.map(v => ({
								label: v,
								value: v,
							})),
					},
				],
			},
			{
				label: "Use as main recommendation (for BOM forecast)",
				key: "recommendation",
				editable: this.state.canEdit,
				formFields: [
					{
						label: "Use as main recommendation (for BOM forecast)",
						name: "recommendation",
						_type: "select-object",
						message: "Error",
						required: true,
						options: [
							{
								value: "max_installed",
								label: "Maximum Quantity Installed per Unit",
							},
							{
								value: "total_installed",
								label: "Total Quantity Installed",
							},
						],
					},
				],
			},
			{
				label: "Percentage (for BOM forecast) (%)",
				key: "recommendation_percentage",
				editable: this.state.canEdit,
				formFields: [
					{
						label: "Percentage (for BOM forecast) (%)",
						name: "recommendation_percentage",
						_type: "number",
						message: "Error",
						required: true,
					},
				],
			},
			{
				label: "Percentage (Total Quantity installed Recommendation) (%)",
				key: "total_quantity_percentage",
				editable: true,
				formFields: [
					{
						label: "Percentage (Total Quantity installed Recommendation) (%)",
						name: "total_quantity_percentage",
						_type: "number",
						max: 100,
						min: 0,
						message: "Error",
						required: true,
					},
				],
			},
			{
				label: "Percentage (Max Quantity installed Recommendation) (%)",
				key: "max_installed_percentage",
				editable: true,
				formFields: [
					{
						label: "Percentage (Max Quantity installed Recommendation) (%)",
						name: "max_installed_percentage",
						_type: "number",
						max: 100,
						min: 0,
						message: "Error",
						required: true,
					},
				],
			},
			{
				label: "Use forecast",
				key: "forecast",
				editable: true,
				formFields: [
					{
						label: "Use as main forecast",
						name: "forecast",
						_type: "select-object",
						message: "Error",
						required: true,
						options: [
							{
								value: "naive",
								label: labelMapper("naive"),
							},
							{
								value: "bom",
								label: labelMapper("bom"),
							},
							{
								value: "combined",
								label: labelMapper("combined"),
							},
						],
					},
				],
			},
			{
				label: "Use Stocking calculator",
				key: "use_stocking_calculator",
				editable: this.state.canEdit,
				formFields: [
					{
						label: "Use Stocking calculator",
						name: "use_stocking_calculator",
						_type: "select-object",
						message: "Error",
						required: true,
						options: [
							{
								value: true,
								label: "Yes",
							},
							{
								value: false,
								label: "No",
							},
						],
					},
				],
			},
			{
				label: "Ranking Applied",
				key: "ranking_applied",
				editable: this.state.canEditRanking,
				formFields: [
					{
						label: "Ranking Applied",
						name: "ranking_applied",
						_type: "select-object",
						message: "Error",
						required: true,
						options: [
							{
								value: "target_sf",
								label: "Target SF",
							},
							...(StockingCalculator.showRankingOption
								? [
										{
											value: "stocking_calculator",
											label: "Stocking Calculator",
										},
									]
								: []),
						],
					},
				],
			},
			{
				label: "Use Demand Smoothing",
				key: "use_demand_smoothing",
				editable: this.state.canEdit,
				formFields: [
					{
						label: "Use Demand Smoothing",
						name: "use_demand_smoothing",
						_type: "select-object",
						message: "Error",
						required: true,
						options: [
							{
								value: true,
								label: "Yes",
							},
							{
								value: false,
								label: "No",
							},
						],
					},
				],
			},
			{
				label: "Smoothing Mode",
				key: "smoothing_mode",
				editable: this.state.canEdit,
				formFields: [
					{
						label: "Smoothing Mode",
						name: "smoothing_mode",
						_type: "select-object",
						message: "Error",
						required: true,
						options: [
							{
								value: "exclude",
								label: "Remove spikes",
							},
							{
								value: "limit",
								label: "Limit spikes",
							},
						],
					},
				],
			},
			{
				label: "Coefficient for Demand Smoothing",
				key: "std_coeff",
				editable: this.state.canEdit,
				formFields: [
					{
						label: "Coefficient for Demand Smoothing",
						name: "std_coeff",
						_type: "number",
						message: "Error",
						required: true,
					},
				],
			},
		]).filter(item => StockingCalculator.showUseSetting || item.key !== "use_stocking_calculator");

	onRecAdd = () => {
		this.getRecs(true);
	};

	onSettingChange = value => {
		this.setState({selectedSetting: value});
	};

	onStockAllocationOpen = item => {
		this.setState({showStockAllocation: true, saInProgress: true});
		api.post(`/projects/${this.state.projectId}/material-analysis/${this.state.material}/stockAllocation`, item)
			.then(response => {
				this.setState({stockAllocation: response.data, selectedRec: item});
				console.log(response);
			})
			.finally(() => this.setState({saInProgress: false}));
	};

	refreshRecommendations = () => {
		this.setState({
			recommendedData: [],
		});
		this.getRecs(false);
		this.getRecs(true);
	};

	render() {
		return (
			<div>
				<PageTitle title={this.state.material} />
				<Row style={{padding: 15}}>
					<Col span={1}>
						<GetBack link={this.state.from} />
					</Col>

					<Col span={16}>
						<MaterialCard
							itemInfo={this.state.itemInfo}
							leadTime={this.state.leadTime}
							canEdit={this.state.canEdit}
							material={this.state.material}
							onEdit={() => this.setState({editModal: true})}
							onHistoryOpen={() => this.setState({historyModal: true})}
							exceptions={this.state.exceptions}
							projectId={this.state.projectId}
							rankingApplied={this.state.materialSettings?.ranking_applied}
							historyCount={this.state.historyCount}
						/>
					</Col>
					<Col span={1} />
					{
						<Col span={6}>
							<AssignApproval
								projectId={this.state.projectId}
								show={this.state.show}
								shouldSelectWorkflow={this.state.shouldSelectWorkflow}
								closeApproval={this.closeApproval}
								onApprove={() => this.getAnalysis()}
								proposedMin={this.state.proposedMin}
								proposedMax={this.state.proposedMax}
								canEdit={this.state.canEdit}
								approvalStatus={value => this.setState({approvalStatus: value})}
								itemInfo={this.state.itemInfo}
							/>
						</Col>
					}
				</Row>

				<Row style={{padding: 15}}>
					<Col span={24}>
						<Tabs
							defaultActiveKey={"11"}
							onChange={activeKey => this.setState({currentTab: activeKey})}
							activeKey={this.state.currentTab}
							style={{marginTop: -15}}>
							{this.state.hasRights && (
								<TabPane tab={`Recommendations Overview`} key={"11"}>
									{this.state.standardLoading && (
										<div style={{float: "left"}}>
											<Spin spinning={this.state.standardLoading} />
											Loading Standard Recommendations
										</div>
									)}
									{this.state.mlLoading && (
										<div style={{float: "right"}}>
											<Spin spinning={this.state.mlLoading} />
											Loading AIML Recommendation
										</div>
									)}
									<div style={{marginTop: 10, marginBottom: 10}}>
										<Select
											style={{width: 500}}
											onChange={this.onSettingChange}
											value={this.state.selectedSetting}
											options={this.state.settingsOptions}
										/>
									</div>

									<RecommendationsTable
										onApprove={this.startApproval}
										approvalStatus={this.state.approvalStatus}
										onForecastOpen={item => this.onForecastOpen(item)}
										couldApprove={!this.state.itemInfo.approved}
										onStockAllocationOpen={this.onStockAllocationOpen}
										loading={this.state.loading}
										onLockRecommendation={updatedData => {
											this.setState({recommendedData: updatedData});
										}}
										useStockCalc={
											(this.state.modelSettings &&
												this.state.modelSettings.use_stocking_calculator) ||
											false
										}
										canEdit={this.state.canEdit}
										projectId={this.state.projectId}
										material={this.state.material}
										data={this.state.recommendedData} // Передаем данные таблицы
										onDeleteSuccess={this.refreshRecommendations}
									/>
								</TabPane>
							)}
							<TabPane tab={`Stock Allocation`} key={"sa"}>
								<StockAllocationTable
									recs={this.getRecommendations()}
									projectId={this.state.projectId}
									material={this.state.material}
								/>
							</TabPane>
							<TabPane tab={`Forecasting`} key={"12"}>
								<Forecasts
									projectId={this.state.projectId}
									material={this.state.material}
									itemInfo={this.state.itemInfo}
									onRecAdd={this.onRecAdd}
									constants={this.state.modelSettings}
									currentRec={this.state.currentRec}
									change={this.state.change}
									handleSelect={this.handleSelect}
									canEdit={!this.state.itemInfo.approved && this.state.canEdit}
									forecastMethod={this.state.forecastMethod}
									forecastMin={this.state.forecastMin}
									forecastMax={this.state.forecastMax}
								/>
							</TabPane>
                            {ExtendedWhereUsedFactors.enabled && (<TabPane tab={"Where-Used factors"} key={"13"}>
                                <ExtendedWhereUsedFactors.FlocksScoresTable
                                    data={this.state.itemInfo.flock_scores}
                                    ihLink={`${createIHLink(this.state.projectId, this.state.material)}&tab=where-used`}
                                />
                                <div
                                    style={{ marginTop: 12, color: "blue", cursor: "pointer", fontWeight: "bold" }}
                                    onClick={this.toggleExtraTable}
                                >
                                    Show extra details
                                </div>
                                {this.state.showExtraTable && (
                                        <ExtendedWhereUsedFactors.WhereUsedTable
                                            data={this.state.itemInfo.where_used_factors}
                                        />
                                )}
                                {this.state.showExtraTable && this.state.itemInfo.where_used_factors_errors > 0 && (
                                    <div style={{ marginTop: 12, color: "red", fontWeight: "bold" }}>
                                        {this.state.itemInfo.where_used_factors_errors} Items doesn't have enough data.
                                        These items will not be taken into account in
                                        the calculations of where used factors.
                                    </div>
                                )}
                            </TabPane>)}
							{StockingCalculator.enabled && (<TabPane tab={`Stocking Calculator`} key={"weight"}>
								<StockingCalculator.Component weight={this.state.weightCalc} itemInfo={this.state.itemInfo} />
							</TabPane>)}
							<TabPane
								tab={`Scenario Outcome (${this.state.presentOutput.length})`}
								key={"scenario_outcome"}>
								<MaterialScenarioOutcome
									so={this.state.presentOutput}
									scenarios={this.state.possibleScenarios}
								/>
							</TabPane>
							{this.state.hasRights && (
								<TabPane tab={`Settings`} key={"settings"}>
									<CustomDescriptions
										span={3}
										data={this.getAdjustableSettings()}
										width={"15%"}
										values={this.getSettingsValues()}
										handleSave={this.handleSave}
									/>
								</TabPane>
							)}
						</Tabs>
					</Col>
				</Row>
				{this.state.editModal && (
					<EditingMaterialModal
						item={this.state.itemInfo}
						canApprove={this.state.canApprove}
						isModalVisible={this.state.editModal}
						closeModal={() => this.setState({editModal: false})}
						save={this.save}
					/>
				)}
				<HistoryModal
					modalProps={{height: "60vh", maxHeight: "60vh", overflowY: "auto"}}
					_id={this.state.itemInfo._id}
					project_id={this.state.projectId}
					material={this.state.material}
					isModalVisible={this.state.historyModal}
					onCancel={this.close}
					onOk={this.close}
					onCountLoaded={count => this.setState({historyCount: count})}
				/>

				{this.state.showStockAllocation && (
					<ModalWindow
						isModalVisible={this.state.showStockAllocation}
						title={"Proposed Stock Allocation"}
						modalProps={{width: "60vw"}}
						onOk={() =>
							this.setState({
								showStockAllocation: false,
								stockAllocation: [],
								selectedRec: null,
							})
						}
						onCancel={() =>
							this.setState({
								showStockAllocation: false,
								stockAllocation: [],
								selectedRec: null,
							})
						}></ModalWindow>
				)}
			</div>
		);
	}
}

function MaterialScenarioOutcome(props) {
	console.log(props);
	const getColumns = () => [
		{
			title: <b>Scenario</b>,
			dataIndex: "scenario_id",
			key: "index",
			render: scenario_id => {
				const scenario = props.scenarios.filter(x => scenario_id === x._id);

				if (scenario.length === 1) {
					return <ScenarioLink id={scenario_id} name={scenario[0].iteration_name} />;
				}

				return scenario_id;
			},
		},
		{
			title: <b>Recommendation</b>,
			dataIndex: "recommendation",
			render: (recommendation, item) => (
				<div>
					{recommendation} - {item.new_rop} / {item.new_max}
				</div>
			),
		},
		{
			title: <b>Bucket Name</b>,
			dataIndex: "bucket_info",
			render: (bucket_info, item) => {
				const scenario = props.scenarios.filter(x => item.scenario_id === x._id);

				if (scenario.length === 1) {
					return <ScenarioLink id={item.scenario_id} name={bucket_info?.name} bucketId={item.bucket_id} />;
				}

				return bucket_info?.name;
			},
		},
		{
			dataIndex: "bucket_info",
			title: <b>Bucket Description</b>,
			render: bucket_info => bucket_info?.description,
		},
		{
			dataIndex: "bucket_info",
			title: <b>Bucket Status</b>,
			render: bucket_info => (bucket_info?.status ? getStatusTag(bucket_info.status) : null),
		},
		{
			title: <b>Bucket Creation Date</b>,
			dataIndex: "bucket_info",
			render: bucket_info => {
				if (!bucket_info) {
					return null;
				}

				const date = new Date(bucket_info.created_at);

				return date.toLocaleDateString("en-US", {
					year: "numeric",
					month: "short",
					day: "numeric",
				});
			},
		},
		{
			title: <b>Bucket Created By</b>,
			dataIndex: "bucket_info",
			render: bucket_info => bucket_info?.created_by,
		},
	];

	return (
		<div>
			<StandardTable
				tableSize={"small"}
				scroll={1000}
				data={props.so}
				tableProps={{width: "100%"}}
				columns={getColumns()}
			/>
		</div>
	);
}

function StockAllocationTable({recs, material, projectId}) {
	const [allocation, setAllocation] = useState([]);
	const [selectedRec, setSelectedRec] = useState({});
	const [selectedIdx, setSelectedIdx] = useState(0);
	const [saInProgress, setSaInProgress] = useState(false);

	const getAllocation = rec => {
		setSaInProgress(true);
		if (rec && Object.keys(rec).includes("max") && Object.keys(rec).includes("min")) {
			api.post(`/projects/${projectId}/material-analysis/${material}/stockAllocation`, rec)
				.then(response => {
					setAllocation(response.data);
				})
				.finally(() => setSaInProgress(false));
		}
	};

	useEffect(() => {
		setSelectedRec(recs[selectedIdx]);
	}, [recs, selectedIdx]);

	useEffect(() => {
		getAllocation(selectedRec);
	}, [selectedRec]);

	const getColumns = () => [
		{
			title: <b>Plant</b>,
			dataIndex: "plant",
			key: "index",
		},
		{
			title: <b>MRP Type</b>,
			dataIndex: "MRP Type",
		},
		{
			dataIndex: "plant_stock_level",
			title: <b>Stock Level</b>,
		},
		{
			dataIndex: "plant_transactions_count",
			title: <b>Transactions</b>,
		},
		{
			title: <b>Installed</b>,
			dataIndex: "quantity",
		},
		{
			title: <b>Current {ROP_MIN_LABEL}</b>,
			dataIndex: "rop",
		},
		{
			title: <b>Current Max</b>,
			dataIndex: "max",
		},
		{
			title: <b>Proposed {ROP_MIN_LABEL}</b>,
			dataIndex: "appr_min",
		},
		{
			title: <b>Proposed Max</b>,
			dataIndex: "appr_max",
		},
		{
			title: <b>{FieldsNaming.lead_time}</b>,
			dataIndex: "plant_lead_time",
		},
		{
			title: <b>Plant Price</b>,
			dataIndex: "plant_price",
		},
	];

	return (
		<div style={{width: "100%", padding: 10}}>
			{selectedRec && (
				<Descriptions>
					<DescriptionsItem labelStyle={{fontWeight: "bold"}} span={3} label={"Selected Recommendation"}>
						<Select
							style={{width: 300}}
							value={selectedIdx}
							onChange={idx => setSelectedIdx(idx)}
							options={recs.map((rec, i) => ({
								value: i,
								label: `[${rec["type"]}] ${rec["name"]}`,
							}))}
						/>
					</DescriptionsItem>
					<DescriptionsItem labelStyle={{fontWeight: "bold"}} span={3} label={`Overall ${ROP_MIN_LABEL}`}>
						{selectedRec["min"]}
					</DescriptionsItem>
					<DescriptionsItem labelStyle={{fontWeight: "bold"}} span={3} label={"Overall MAX"}>
						{selectedRec["max"]}
					</DescriptionsItem>
				</Descriptions>
			)}
			<Spin spinning={saInProgress}>
				<StandardTable
					tableSize={"small"}
					scroll={1000}
					data={allocation}
					tableProps={{width: "100%"}}
					columns={getColumns()}
				/>
			</Spin>
		</div>
	);
}

MinMaxItem.contextType = CurrentUserContext;
